
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'


import i18n from '@/plugins/i18n';

const AccessControl = require('accesscontrol')
const FormData = require('form-data')
const vm = new Vue()

import { Preferences } from '@capacitor/preferences';
import popup_confirm from '../components/modals/PopupConfirm.vue'
import popup_apprelease from '../components/modals/PopupAppRelease.vue'

Vue.use(Vuex)

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    let publicpages=["ReviewUser"]
    if(publicpages.indexOf(router.lastdestination)==-1){
      store.dispatch('logout')
      router.push('/')
    }
  }
  return Promise.reject(error)
})



router.beforeEach((to, from, next) => {
  router.lastdestination = to.name
  console.log(">>NAVTO>>", to.name , from.name)
  // if(to.name == from.name){
  //   next();
  //   return
  // }
  if(to.name=='Carousel'){
      store.dispatch('get_carousel_people')
      store.dispatch('get_carousel_professions')

  }
  if(to.name == "PublicProjects" || to.name == "PublicProject"){
      store.dispatch('get_public_projects')
      store.dispatch('public_settings')
  }
  if (to.name == 'Register' ||
      to.name == 'NewProject' ||
      to.name == 'AboutApp' ||
      to.name == 'AboutZZPR' ||
      to.name == 'Terms'  ||
      to.name == 'Privacy'  ||
      to.name == 'RootView'     
    ){
    store.dispatch('public_settings')
  }
  if(to.name == "Login"){
    store.dispatch('public_settings')

  }
  if (store.getters.is_logged_in){
    store.dispatch('get_settings')
    store.dispatch('get_pms')
    store.dispatch('get_documents')

    if(to.name == "Todo"){
      store.dispatch('get_users')
      store.dispatch('get_todo')

    }

    if (to.name == "Users") {
      store.dispatch('get_users')
      store.dispatch('get_branches')
      // store.dispatch('get_avatars')
      store.dispatch('get_planning')
      store.dispatch('get_workfields')
      store.dispatch('get_tags')
      store.dispatch('get_contracts')
      store.dispatch('get_urenbonnen')
      store.dispatch('get_invoiceextra')
    }
    if (to.name == "User") {
      console.log(">>>>>>",to, )
      store.dispatch('get_users')
      store.dispatch('get_branches')
      // store.dispatch('get_avatars')
      store.dispatch('get_planning')
      store.dispatch('get_workfields')
      store.dispatch('get_projects')
      store.dispatch('get_contracts')
      store.dispatch('get_declaraties')
      // store.dispatch('get_hours')
      store.dispatch('get_user_hours', to)
      store.dispatch('get_urenbonnen')
      store.dispatch('get_invoiceextra')
        store.dispatch('get_signatures')

    }
    if (to.name == "Companies") {
      store.dispatch('get_users')
      store.dispatch('get_companies')
      store.dispatch('get_branches')
      store.dispatch('get_tags')
      // store.dispatch('get_company_avatars')
    }
    if (to.name == "Company") {
      store.dispatch('get_users')
      store.dispatch('get_companies')
      store.dispatch('get_branches')
      store.dispatch('get_tags')
      store.dispatch('get_projects')
    }
    if (to.name == "Projects") {
      store.dispatch('get_branches')
      store.dispatch('get_projects')
      store.dispatch('get_workfields')
    }
    if (to.name == "Project") {
      // store.dispatch('get_users')
      store.dispatch('get_projects')
      store.dispatch('get_companies')
      store.dispatch('get_contracts')
      store.dispatch('get_hourcodes')
      store.dispatch('get_planning')

    }
    if (to.name == "Contracts") {
      store.dispatch('get_users')
      store.dispatch('get_projects')
      store.dispatch('get_companies')
      store.dispatch('get_contracts')
      store.dispatch('get_planning')
      store.dispatch('get_branches')
    }
    if (to.name == "Planning" || to.name == "PlanningPerWeek") {
      // store.dispatch('get_users')
      store.dispatch('get_projects')
      store.dispatch('get_companies')
      store.dispatch('get_contracts')
      store.dispatch('get_planning')
      store.dispatch('get_branches')
    }
    if (to.name == "Hourcodes") {
      store.dispatch('get_hourcodes')
    }
    if (to.name == "Tags") {
      store.dispatch('get_tags')
    }
    if (to.name == "Branches" || to.name == "Branche") {
      store.dispatch('get_branches')
      store.dispatch('get_workfields')
    }
    if (to.name == "Invoices") {
      store.dispatch('get_settings')
      store.dispatch('get_contracts')
      store.dispatch('get_urenbonnen')
      store.dispatch('get_hours')
      store.dispatch('get_facturen')
    }
    if (to.name == "Hours") {
      store.dispatch('get_settings')
      store.dispatch('get_contracts')
      store.dispatch('get_urenbonnen')
      store.dispatch('get_hours')
      store.dispatch('get_invoiceextra')
    }
    if (to.name == "UserTasks") {
      store.dispatch('get_contracts')
      store.dispatch('get_urenbonnen')
      store.dispatch('get_hours')
      store.dispatch('get_planning')
      store.dispatch('get_projects')
      store.dispatch('get_invoiceextra')

    }
    if (to.name == "UserHours") {
      store.dispatch('get_companies')
      store.dispatch('get_declaraties')
      store.dispatch('get_contracts')
      store.dispatch('get_urenbonnen')
      store.dispatch('get_hours')
      store.dispatch('get_planning')
      store.dispatch('get_projects')
      store.dispatch('get_settings')
    }
    if (to.name == "BicCodes") {
      store.dispatch('get_biccodes')
    }
    if (to.name == "Dashboard" ) {
      store.dispatch('get_hours')
    }
    if (to.name =="Resources" ||to.name =="Schedule"){
      store.dispatch('get_resources')
      store.dispatch('get_ffwax')
      store.dispatch('get_workfields')
      store.dispatch('get_planning')


    }
  }
  next();
});

const store = new Vuex.Store({
  state: {
    loading: false,
    firebasetoken:"",

    //SERVER SETTINGS
    api_protocol: 'http://',
    api_host: 'localhost',
    api_port: '12346',
    api_heartbeat: '10000',
    server_online: false,

    //ROLES
    roles: null,
    //USER DATA
    current_user: null,
    settings: {},
    users: [],
    projects: [],
    companies: [],
    contracts: [],
    branches: [],
    workfields: [],
    hourcategories: [],
    hourcodes: [],
    avatars: [],
    companyavatars: [],
    planning: [],
    tags: [],
    hours: [],
    facturen: [],
    combinedfacturen: [],
    selectedZZPr: null,
    showBlacklist: 1,
    declaraties: [],
    documents: [],
    urenbonnen: [],
    emailsenders: [],
    authemailsenders: [], 
    invoiceextra:[],
    biccodes:[],
    nationalities:[],
    planningrules:[],
    planningruletypes:[],
    weekshistory:12,
    appnavvisible:false,
    notifications:[],
    todo:[],
    pms:[],
    loaders:0,
    newsletters:[],
    signatures:[],
    resources: [],
    ffwax: [],
    projectresources: [],

    search_settings:{            
      currentbranche: -1,
      owner: -1,
      selectedtag: null,
      selectedload:null,
      selectedID: null,
      waardering: [],
      nieuwsbrief: 0,
      status: ["0", "1", "2", "3", "4", "5"],
      accountstatus: [],
      company: null,
      zipcode: "",
      radius: "",
      componentKey: 0,
      distanceResult: null,
      dobfrom: null,
      dobto: null,
      selected_branches: 0,
      selected_workfields: [],
      available_filter: 1,
      date_available_from: null,
      date_available_to: null,
      date_working_from: null,
      date_working_to: null,
      date_working_full: null,
      nabellenfrom: null,
      nabellento: null,
      expireWeeks:2,
      docID:0,
      docKVK:0,
      docGPI:0,
      docVCA:0,
      docAVB:0,
      docAny:0,
      docBTW:0,
      hasdoc:1,
      hasdocID:0,
      hasdocKVK:0,
      hasdocGPI:0,
      hasdocVCA:0,      
      hasdocAVB:0,      
      currentrole: -1,
      signupdate_from:null,
      signupdate_to:null,
      tabIndex:0,
      contactrole:"selectall",
      filter:""
    },
    usersettings:{
      filter:null,
      currentbranche:-1,
      currentrole:-1,
      owner:-1, 
      selectedtag:null,
      currentPage:1,
      showblacklist:0,
      statusactiveusers:1
    },
    companysettings:{
      filter:null,
      currentbranche:-1,
      currentrole:-1,
      owner:-1, 
      selectedtag:null,
      currentPage:1,
      showblacklist:0
    },
    projectsettings:{
      filter:null,
      currentbranche:-1,
      only_public:"1",
      currentPage:1,

    },
    userhourmodal_settings:{
      contract_id:null,
      day:"",
      select:false,
      fromLayer:false,
      normalhours:-1,
      workhoursstart:null,
      workhoursend:null
    },
    resourceTypes:
       [
        {id:1,value:"vervoer" , label: "Vervoer"},
        {id:2,value:"materiaal" , label: "Materiaal"},
        {id:3,value:"gereedschap" , label: "Gereedschap"},
      ],      
    timerposition:{lat:null, long:null},
    //NEW
    new_project: { id: 0, company_id: 0, contactpersons: [], workfields: [] },
    new_user: {
      id: 0,
      branche_id: 1,
      workfields: [],
      role:'user',
      owner_id: 0,
      active: 1,
      language: "nl",
      country: "NL",
      notifications: 1,
      newsletter: 1,
      mail: 1,
      sms: 1,
      inapp: 1,
      company_contact: 0,
      invoice_contant: 0,
      document_contact: 0,
      sign_contact: 0,
      location_contact: 0,
      isemployee:0
    },
    new_hourcode: { id: 0, active: 1, parent: -1 },
    new_contract: { id: 0, project_id: 0, user_id: 0, signed: 0 },
    new_planning: { id: 0, project_id: 0, user_id: 0, pointcontact_id: 0, sign_id: 0 },
    new_company: { id: 0 },
    new_workhourcheck :{ id: 0,workhoursstart:null,workhoursend:null, workhourspause:0, signed_by:"" },
    modal_confirm: { id: 0 },
    new_user_id: 0,
    current_company: 0,
    last_contract_id: 0,
    portal_selected :false,
    portal_extra:false,
    current_portal:"",
    loginfailed:false,
    totalPending:0,
    totalSigned:0,
    totalClosed:0,
    signerTotalSigned:0,
    signerTotalClosed:0, 
    appReleaseNumber:40,
    carouselToken:null,
    carouselID:0,
    carouselURL:"https://carousel.flyingfreelancers.nl/",
    carouselPeople:[],
    carouselProfessions:[],
    carouselUser:null
  },
  mounted() {
   console.log("store mounted");


  },  
  getters: {
    //USER GETTERS
    is_logged_in: (state) => {
      return state.current_user != null;
    },
    is_portal_selected:(state) => {
      return state.portal_selected
    },
    portal_has_extras:(state) => {
      return state.portal_extra
    },
    append_data_string: (state) => {
      var ret = ""
      if (state.current_user) {
        if (state.current_user.firstname) {
          ret += state.current_user.firstname.charAt(0)
        }
        if (state.current_user.lastname) {
          ret += state.current_user.lastname.charAt(0)
        }
      }
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      console.log(">>>>>>>", yyyy, mm, dd)
      return dd + mm + yyyy.toString().substr(-2) + ret + " "
    },
    user_index_by_user_id: (state) => {
      return state.users.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    user_by_id: (state, getters) => (id) => {
      return state.users[getters.user_index_by_user_id[id]]
    },
    user_photo_by_id: (state) => (id) => {
      let data;
      for (var i = 0; i < state.avatars.length; i++) {
        if (state.avatars[i].user_id == id) {
          data = state.avatars[i].image.data;
          break;
        }
      }
      let myString = ""
      if (data) {
        for (var j = 0; j < data.length; j++) {
          myString += String.fromCharCode(data[j])
        }
      } else {
        myString = "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"
      }
      return myString;
    },
    username_by_id: (state, getters) => (id) => {
      let user = state.users[getters.user_index_by_user_id[id]]
      if (user) {
        var name = ""
        if (user.firstname) {
          name += user.firstname
        }
        if (user.middlename) {
          name += " " + user.middlename
        }
        if (user.lastname) {
          name += " " + user.lastname
        }
        return name
      } else {
        return ""
      }
    },

    selectedZZPr: (state) => {
      return state.selectedZZPr
    },
    showBlacklist: (state) => {
      return state.showBlacklist
    },
    weekshistory: (state) => {
      return state.weekshistory
    },
    appnavvisible: (state) => {
      return state.appnavvisible
    },
    contactpersonen: (state) => {
      return state.users.filter(
        user => user.role == "contactpersoon" || (user.role=='admin' && user.sign_contact=='1')
      )
    },
    opdrachtgevers: (state) => {
      return state.users.filter(
        user => user.role == "opdrachtgever"
      )
    },
    zzpers: (state) => {
      return state.users.filter(
        user => user.role == "user"
      )
    },
    admins: (state) => {
      return state.users.filter(
        user => user.role == "admin"
      )
    },
    companies_index_by_company_id: (state) => {
      return state.companies.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    company_by_id: (state, getters) => (id) => {
      return state.companies[getters.companies_index_by_company_id[id]]
    },
    companyname_by_id: (state, getters) => (id) => {
      let comp = state.companies[getters.companies_index_by_company_id[id]]
      return comp ? comp.company_name : ""

    },
    company_logo_by_id: (state) => (id) => {
      let data;
      for (var i = 0; i < state.companyavatars.length; i++) {
        if (state.companyavatars[i].company_id == id) {
          data = state.companyavatars[i].image.data;
          break;
        }
      }
      let myString = ""
      if (data) {
        for (var j = 0; j < data.length; j++) {
          myString += String.fromCharCode(data[j])
        }
      } else {
        myString = "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"
      }
      return myString;
    },
    project_index_by_project_id: (state) => {
      return state.projects.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    project_by_id: (state, getters) => (id) => {
      return state.projects[getters.project_index_by_project_id[id]]
    },
    project_new: (state) => {
      return state.new_project
    },
    workhourcheck_new: (state) =>{
      return state.new_workhourcheck
    },
    user_new: (state) => {
      return state.new_user
    },
    last_user_id: (state) => {
      return state.new_user_id
    },
    company_new: (state) => {
      return state.new_company
    },
    contract_index_by_contract_id: (state) => {
      return state.contracts.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    contract_by_id: (state, getters) => (id) => {
      return state.contracts[getters.contract_index_by_contract_id[id]]

    },
    contract_new: (state) => {
      return state.new_contract
    },
    find_contract_id: (state) => (project_id, user_id) => {
      let c = state.contracts.filter(contract => contract.project_id == project_id && contract.user_id == user_id) 
      return c.length==0?null:c[0].id
    },
    branche_index_by_branche_id: (state) => {
      return state.branches.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    branche_by_id: (state, getters) => (id) => {
      return state.branches[getters.branche_index_by_branche_id[id]]

    },
    activebranches: (state) => {
      return state.branches.filter(branche => branche.active==1)
      // let active_branches = [];
      // for (var i = 0; i < state.branches.length; i++) {
      //   if (state.branches[i].active == 1) {
      //     active_branches.push(state.branches[i])
      //   }
      // }
      // return active_branches
    },
    activeemailsenders: (state) => {
      // let active_branches = [];
      // for (var i = 0; i < state.branches.length; i++) {
      //   if (state.branches[i].active == 1) {
      //     active_branches.push(state.branches[i])
      //   }
      // }
      return state.emailsenders.filter(sender =>sender.active=='1')
    },    
    active_workfields_in_branche: (state) => (branche_id) => {
      let active_workfields = [];
      state.workfields.forEach(workfield => {
        if (workfield.branche_id == branche_id && workfield.active == 1) {
          active_workfields.push(workfield)
        }
      })

      return active_workfields
    },
    workfield_index_by_workfield_id: (state) => {
      return state.workfields.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    workfield_by_id: (state, getters) => (id) => {
      return state.workfields[getters.workfield_index_by_workfield_id[id]]

    },
    hourcategory_index_by_hourcategory_id: (state) => {
      return state.hourcategories.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    hourcategory_by_id: (state, getters) => (id) => {
      return state.hourcategories[getters.hourcategory_index_by_hourcategory_id[id]]
    },
    activehourcategories: (state) => {
      return state.hourcategories.filter(category => category.active==1)
    },
    hourcodes_index_by_hourcode_id: (state) => {
      return state.hourcodes.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    hourcode_by_id: (state, getters) => (id) => {
      return state.hourcodes[getters.hourcodes_index_by_hourcode_id[id]]
    },
    hourcode_new: (state) => {
      return state.new_hourcode
    },
    planning_index_by_planning_id: (state) => {
      return state.planning.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    planning_by_id: (state, getters) => (id) => {
      return state.planning[getters.planning_index_by_planning_id[id]]
    },
    planning_new: (state) => {
      return state.new_planning
    },
    find_planning: (state) => (project_id, user_id) => {
      return state.planning.filter(plan => plan.project_id == project_id && plan.user_id == user_id)[0]
      // for (var i = 0; i < state.planning.length; i++) {
      //   if (state.planning[i].project_id == project_id && state.planning[i].user_id == user_id) {
      //     return state.planning[i]
      //   }
      // }
      // return null
    },
    find_last_planning_user: (state) => (user_id) => {
      let lastdate = new Date('1970-01-01')
      state.planning.filter(plan => plan.user_id== user_id).forEach( plan => {
        if (new Date(plan.enddate) > lastdate) {
          lastdate = new Date(plan.enddate)
        }
      })
      return lastdate
    },
    find_last_company_user: (state, getters) => (user_id) => {
      let lastdate = new Date('1970-01-01')
      let project_id = null
      state.planning.filter(plan => plan.user_id == user_id).forEach(plan =>{
        if (new Date(plan.startdate) > lastdate) {
          lastdate = new Date(plan.startdate)
          project_id = plan.project_id
        }        
      })
      // for (var i = 0; i < state.planning.length; i++) {
      //   if (state.planning[i].user_id == user_id) {
      //     if (new Date(state.planning[i].startdate) > lastdate) {
      //       lastdate = new Date(state.planning[i].startdate)
      //       project_id = state.planning[i].project_id
      //     }
      //   }
      // }
      return project_id ? getters.project_by_id(project_id).company_id : null
    },
    find_last_planning_company: (state) => (company_id) => {
      let lastdate = new Date('1970-01-01')
      state.projects.filter(project => project.company_id == company_id).forEach(project => {
        state.planning.filter(plan => plan.project_id == project.id).forEach(plan =>{
          if (new Date(plan.enddate)>lastdate) {
            lastdate = new Date(plan.enddate)
          }
        })
      })
      // for (var p = 0; p < state.projects.length; p++) {
      //   if (state.projects[p].company_id == company_id) {
      //     for (var i = 0; i < state.planning.length; i++) {
      //       if (state.planning[i].project_id == state.projects[p].id) {
      //         if (new Date(state.planning[i].enddate) > lastdate) {
      //           lastdate = new Date(state.planning[i].enddate)
      //         }
      //       }
      //     }
      //   }
      // }
      return lastdate
    },
    tag_index_by_tag_id: (state) => {
      return state.tags.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    tag_by_id: (state, getters) => (id) => {
      return state.tags[getters.tag_index_by_tag_id[id]]
    },
    resource_index_by_resource_id: (state) => {
      return state.resources.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    resource_by_id: (state, getters) => (id) => {
      return state.resources[getters.resource_index_by_resource_id[id]]
    },  
    projectresource_index_by_projectresource_id: (state) => {
      return state.projectresources.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    projectresource_by_id: (state, getters) => (id) => {
      return state.projectresources[getters.projectresource_index_by_projectresource_id[id]]
    },       
    ffwax_index_by_ffwax_id: (state) => {
      return state.ffwax.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    ffwax_by_id: (state, getters) => (id) => {
      return state.ffwax[getters.ffwax_index_by_ffwax_id[id]]
    },        
    newsletter_index_by_newsletter_id: (state) => {
      return state.newsletters.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    newsletter_by_id: (state, getters) => (id) => {
      return state.newsletters[getters.newsletter_index_by_newsletter_id[id]]
    },
    signature_index_by_signature_id: (state) => {
      return state.signatures.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    signature_by_id: (state, getters) => (id) => {
      return state.signatures[getters.signature_index_by_signature_id[id]]
    },    
    biccode_index_by_bic_id: (state) => {
      return state.biccodes.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    biccode_by_id: (state, getters) => (id) => {
      return state.biccodes[getters.biccode_index_by_bic_id[id]]
    }, 
    nationality_index_by_id: (state) => {
      return state.nationalities.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    nationality_by_id: (state, getters) => (id) => {
      return state.nationalities[getters.nationality_index_by_id[id]]
    }, 
    planningrule_index_by_id: (state) => {
      return state.planningrules.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    planningrule_by_id: (state, getters) => (id) => {
      return state.planningrules[getters.planningrule_index_by_id[id]]
    },
    planningruletype_index_by_id: (state) => {
      return state.planningruletypes.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    planningruletype_by_id: (state, getters) => (id) => {
      return state.planningruletypes[getters.planningruletype_index_by_id[id]]
    },            
    declaratie_index_by_declaratie_id: (state) => {
      return state.declaraties.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    declaratie_by_id: (state, getters) => (id) => {
      return state.declaraties[getters.declaratie_index_by_declaratie_id[id]]
    },
    activedeclaraties: (state) => {
      return state.declaraties.filter(declaratie => declaratie.active ==1)
      // let active_declaraties = [];
      // for (var i = 0; i < state.declaraties.length; i++) {
      //   if (state.declaraties[i].active == 1) {
      //     active_declaraties.push(state.declaraties[i])
      //   }
      // }
      // return active_declaraties
    },
    document_index_by_document_id: (state) => {
      return state.documents.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    document_by_id: (state, getters) => (id) => {
      return state.documents[getters.document_index_by_document_id[id]]
    },
    hours_index_by_hours_id: (state) => {
      return state.hours.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    hours_by_id: (state, getters) => (id) => {
      return state.hours[getters.hours_index_by_hours_id[id]]
    },
    urenbon_index_by_urenbon_id: (state) => {
      return state.urenbonnen.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    urenbon_by_id: (state, getters) => (id) => {
      return state.urenbonnen[getters.urenbon_index_by_urenbon_id[id]]
    },
    factuur_index_by_factuur_id: (state) => {
      return state.facturen.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    factuur_by_id: (state, getters) => (id) => {
      return state.facturen[getters.factuur_index_by_factuur_id[id]]
    },
    combinedfactuur_by_id: (state, getters) => (id) => {
      return state.combinedfacturen[getters.combinedfactuur_index_by_factuur_id[id]]
    },    
    combinedfactuur_index_by_factuur_id: (state) => {
      return state.combinedfacturen.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },

    emailsender_index_by_emailsender_id: (state) => {
      return state.emailsenders.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    emailsender_by_id: (state, getters) => (id) => {
      return state.emailsenders[getters.emailsender_index_by_emailsender_id[id]]
    },
    todo_index_by_todo_id: (state) => {
      return state.todo.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    todo_by_id: (state, getters) => (id) => {
      return state.todo[getters.todo_index_by_todo_id[id]]
    },  
    pm_index_by_pm_id: (state) => {
      return state.pms.reduce((map, item, index) => {
        map[item.id] = index
        return map
      }, {})
    },
    pm_by_id: (state, getters) => (id) => {
      return state.pms[getters.pm_index_by_pm_id[id]]
    },        
    role: (state) => {
      return state.current_user?state.current_user.role:"user"
    },
    createAny: (state, getters) => (resource) => {
      if (state.roles != null) {
        return state.roles.can(getters.role).createAny(resource).granted
      }
      return false;
    },
    readAny: (state, getters) => (resource) => {
      if (state.roles != null) {
        return state.roles.can(getters.role).readAny(resource).granted
      }
      return false;
    },
    updateAny: (state, getters) => (resource) => {
      if (state.roles != null) {
        return state.roles.can(getters.role).updateAny(resource).granted
      }
      return false;
    },
    deleteAny: (state, getters) => (resource) => {
      if (state.roles != null) {
        return state.roles.can(getters.role).deleteAny(resource).granted
      }
      return false;
    },

    //METAS
    user_metas: (state) => {
      return state.settings.user_metas.filter((item) => item.type != 'checkbox');
    },
    project_metas: (state) => {
      return state.settings.project_metas.filter((item) => item.type != 'checkbox');
    },
    companies_metas: (state) => {
      return state.settings.companies_metas.filter((item) => item.type != 'checkbox');
    },
    contracts_metas: (state) => {
      return state.settings.contracts_metas.filter((item) => item.type != 'checkbox');
    },
    user_settings_metas: (state) => {
      return state.settings.user_settings_metas.filter((item) => item.type != 'checkbox');
    },
    user_settings_metasCB: (state) => {
      return state.settings.user_settings_metas.filter((item) => item.type == 'checkbox');
    },
    //MODAL
    confirm_modal: (state) => {
      return state.modal_confirm
    },
    //host
    server_url: (state) => {
      require('dotenv').config()
      if (process.env.VUE_APP_BUILD_TARGET=="apprelease") {
        return state.current_portal+"api"
      } else {
        return '/api'
      }
    },
    portal_logo:(state) =>{
      require('dotenv').config()
      if (process.env.VUE_APP_BUILD_TARGET=="apprelease") {
        return state.current_portal+"logo.svg"
      } else {
        return 'https://portal.zzpr.nl/logo.svg'
      }      
    },
    current_company: (state) => {
      return state.current_company
    },
    owners: (state) => {
      return state.users.filter(user => user.role == "admin")
      // let adminusers = []
      // for (var i = 0; i < state.users.length; i++) {
      //   if (state.users[i].role == "admin") {
      //     adminusers.push(state.users[i])
      //   }
      // }
      // return adminusers
    },
    barebiccodes: (state) => {
      return state.biccodes.map(x=>x.code)
    },
    notifications:(state) => {
      return state.notifications
    },
    todo:(state) => {
      return state.todo
    },
    pms:(state) => {
      return state.pms
    },    
    carouselToken:(state) =>{
      return state.carouselToken
    },
    carouselURL:(state) =>{
      return state.carouselURL
    },
    carouselID:(state) =>{
      return state.carouselID
    },
    carouselPeople:(state) =>{
      return state.carouselPeople
    },
    carouselProfessions:(state) =>{
      return state.carouselProfessions
    },
    carouselUser:(state) => {
      return state.carouselUser
    }
    // resourceTypes(){
    //   return [
    //     {id:1,value:"vervoer" , label: "Vervoer"},
    //     {id:2,value:"materiaal" , label: "Materiaal"},
    //     {id:3,value:"gereedschap" , label: "Gereedschap"},
    //   ]
    // },  
  },
  mutations: {
    ///API SETTINGS
    /*
    api_protocol(state, api_protocol) {
      state.api_protocol = api_protocol
      axios.defaults.baseURL = state.api_protocol + state.api_host + ':' + state.api_port
    },
    api_host(state, api_host) {
      state.api_host = api_host
      axios.defaults.baseURL = state.api_protocol + state.api_host + ':' + state.api_port
    },
    api_port(state, api_port) {
      state.api_port = api_port
      axios.defaults.baseURL = state.api_protocol + state.api_host + ':' + state.api_port
    },
    api_heartbeat(state, api_heartbeat) {
      state.api_heartbeat = api_heartbeat
    },
    */
    //SERVER MUTATIONS
    server_online(state, online) {
      state.server_online = online;
    },
    loading(state, loading) {
      // console.log("loading",state.loaders)

      if(loading==true){
        state.loaders+=1
      } else{
        state.loaders-=1
      }
      state.loading = loading
    },
    loginfailed(state, loginfailed) {
      state.loginfailed = loginfailed
    },
    firebasetoken(state, firebasetoken){
      state.firebasetoken = firebasetoken
    },
    selectedPortal(state,portal){
      state.portal_selected = true
      state.current_portal = portal
    },
    resetPortal(state){
      state.portal_selected = false
      state.current_portal = ""
    },  
    setPortalExtra(state, extra){
      state.portal_extra = extra
    },    
    totalPending(state, totalPending){
      state.totalPending = totalPending
    },    
    totalSigned(state, totalSigned){
      state.totalSigned = totalSigned
    },    
    totalClosed(state, totalClosed){
      state.totalClosed = totalClosed
    }, 
    signerTotalClosed(state, signerTotalClosed){
      state.signerTotalClosed = signerTotalClosed
    }, 
    signerTotalSigned(state, signerTotalSigned){
      state.signerTotalSigned = signerTotalSigned
    },                
    //USER MUTATIONS
    current_user(state, current_user) {
      state.current_user = current_user;
      //set default language for user
      if (current_user && current_user.language != null && current_user.language != undefined) {
        i18n.locale = current_user.language
      }
    },
    users(state, users) {
      state.users = users
    },
    selectedZZPr: (state, selectedZZPr) => {
      state.selectedZZPr = selectedZZPr;
    },
    showBlacklist: (state, showBlacklist) => {
      state.showBlacklist = showBlacklist;
    },
    weekshistory: (state, weekshistory) => {
      state.weekshistory = weekshistory;
    },
    appnavvisible: (state, appnavvisible) => {
      state.appnavvisible = appnavvisible;
    },
    companies(state, companies) {
      state.companies = companies
    },
    projects(state, projects) {
      state.projects = projects
    },
    contracts(state, contracts) {
      state.contracts = contracts
    },
    branches(state, branches) {
      state.branches = branches
    },
    workfields(state, workfields) {
      state.workfields = workfields
    },
    hourcategories(state, hourcategories) {
      state.hourcategories = hourcategories
    },
    hourcodes(state, hourcodes) {
      state.hourcodes = hourcodes
    },
    avatars(state, avatars) {
      state.avatars = avatars
    },
    companyavatars(state, companyavatars) {
      state.companyavatars = companyavatars
    },
    planning(state, planning) {
      state.planning = planning
    },
    tags(state, tags) {
      state.tags = tags
    },
    resources(state, resources) {
      state.resources = resources
    }, 
    projectresources(state, projectresources) {
      state.projectresources = projectresources
    },     
    ffwax(state, ffwax) {
      state.ffwax = ffwax
    },    
    newsletters(state, newsletters){
      state.newsletters = newsletters
    },
    signatures(state, signatures){
      state.signatures = signatures
    },
    search_settings(state, search_settings){
      state.search_settings = search_settings
    },
    usersettings(state, usersettings){
      state.usersettings = usersettings
    },
    companysettings(state, companysettings){
      state.companysettings = companysettings
    },  
    projectsettings  (state, projectsettings){
      state.projectsettings = projectsettings
    },  
    timerposition(state, timerposition){
      state.timerposition = timerposition
    },
    userhourmodal_settings(state, userhourmodal_settings){
      state.userhourmodal_settings = userhourmodal_settings
    },
    biccodes(state, biccodes) {
      state.biccodes = biccodes
    },
    nationalities(state, nationalities){
      state.nationalities = nationalities
    },
    planningrules(state, planningrules){
      state.planningrules = planningrules
    },
    planningruletypes(state, planningruletypes){
      state.planningruletypes = planningruletypes
    },
    hours(state, hours) {
      state.hours = hours
    },
    declaraties(state, declaraties) {
      state.declaraties = declaraties
    },
    documents(state, documents) {
      state.documents = documents
    },
    urenbonnen(state, urenbonnen) {
      state.urenbonnen = urenbonnen
    },
    facturen(state, facturen) {
      state.facturen = facturen
    },
    combinedfacturen(state, combinedfacturen) {
      state.combinedfacturen = combinedfacturen
    },
    //SETTINGS
    settings(state, newSettings) {
      Object.keys(newSettings).forEach(function (key) {
        var value = newSettings[key];
        Vue.set(state.settings, key, value);
      });
    },
    roles(state, roles) {
      state.roles = new AccessControl(roles)
    },
    new_project(state, new_project) {
      state.new_project = new_project
    },
    new_workhourcheck(state, new_workhourcheck) {
      state.new_workhourcheck = new_workhourcheck
    },
    new_user(state, new_user) {
      state.new_user = new_user
      state.new_user.password ="passwordisemptyoncreate"
    },
    new_contract(state, new_contract) {
      state.new_contract = new_contract
    },
    new_planning: (state, new_planning) => {
      state.new_planning = new_planning;
    },
    new_company(state, new_company) {
      state.new_company = new_company
    },
    new_hourcode(state, new_hourcode) {
      state.new_hourcode = new_hourcode
    },
    modal_confirm(state, modal_confirm) {
      state.modal_confirm = modal_confirm
    },
    current_company(state, current_company) {
      state.current_company = current_company
    },
    last_contract_id(state, last_contract_id) {
      state.last_contract_id = last_contract_id;
    },
    emailsenders(state, emailsenders) {
      state.emailsenders = emailsenders
    },
    authemailsenders(state, authemailsenders) {
      state.authemailsenders = authemailsenders
    },
    invoiceextra(state, invoiceextra) {
      state.invoiceextra = invoiceextra
    },
    todo(state, todo) {
      state.todo = todo
    },    
    pms(state, pms) {
      state.pms = pms
    },
    carouselToken(state, carouselToken) {
      state.carouselToken = carouselToken
    },
    carouselID(state, carouselID) {
      state.carouselID = carouselID
    },
    carouselPeople(state, carouselPeople) {
      state.carouselPeople = carouselPeople
    },
    carouselProfessions(state, carouselProfessions) {
      state.carouselProfessions = carouselProfessions
    },
    carouselUser(state, carouselUser) {
      state.carouselUser = carouselUser
    }

  },
  actions: {
    async initialize({ dispatch , state}) {
      dispatch('get_users')
      dispatch('get_current_user')
      dispatch('get_settings')
      dispatch('get_companies')
      dispatch('get_projects')
      dispatch('get_contracts')
      dispatch('get_branches')
      dispatch('get_workfields')
      dispatch('get_hourcategories')
      dispatch('get_hourcodes')
      // dispatch('get_avatars')
      dispatch('get_planning')
      dispatch('get_tags')
      dispatch('get_hours')
      // dispatch('get_company_avatars')
      dispatch('get_declaraties')
      dispatch('get_documents')
      dispatch('get_urenbonnen')
      dispatch('get_facturen')
      dispatch('get_combinedfacturen')
      dispatch('get_emailsenders')
      dispatch('get_authemailsenders')
      dispatch('get_biccodes')
      dispatch('get_nationalities')
      dispatch('get_planningrules')
      dispatch('get_planningruletypes')
      dispatch('get_invoiceextra')
      dispatch('get_todo')
      dispatch('get_pms')
      dispatch('get_newsletters')
      dispatch('get_signatures')
      dispatch('get_resources')
      dispatch('get_projectresources')
      dispatch('get_ffwax')
      if(state.settings.useCarousel ){
        dispatch('get_carousel_people')
        dispatch('get_carousel_professions')
      }
      if (process.env.VUE_APP_BUILD_TARGET=="apprelease") {
        let apprelease = await axios.get('https://admin.flyingfreelancers.nl/api/app_release')
        if(apprelease &&apprelease.status==200){
          if(state.appReleaseNumber<parseInt(apprelease.data)){
            //notify new app
            vm.$modal.hide('popup_apprelease')
            vm.$modal.show(popup_apprelease, {
              message: "Je gebruikt niet de laatste versie van de app. Ga naar je appstore en update de app" ,
              header: "Nieuwe versie van de app beschikbaar"
            } , {
              name: 'popup_apprelease',
              draggable: false,
              height: 'auto',
              width: '90%'
          })
          }
        }
      }


    },
    //LOGGED IN USER ACTIONS
    get_current_user({ state, commit }) {
      axios.get("/api/user").then((response) => {
        if (state.current_user == null || response.data.user.id != state.current_user.id) {
          commit('current_user', response.data.user);

        }
      })
        .catch((error) => {
          console.log("dontknow",error)

          commit('current_user', null);
        });
    },
    login({ dispatch, commit }, { username, password }) {
      // console.log(">>LOGIN", username, password)
      axios.post('/api/login', { username: username, password: password })
        .then(async (response) => {
          commit('loginfailed', false);
          if (response && response.data) {

            require('dotenv').config()
            if (process.env.VUE_APP_BUILD_TARGET=="apprelease") {
              axios.defaults.headers.common['X-mobile-USERID'] = response.data[0].id
              await Preferences.set({
                key: 'username',
                value: JSON.stringify({
                  name: username
                })
              });
              await Preferences.set({
                key: 'password',
                value: JSON.stringify({
                  name: password
                })
              });              
              dispatch('get_current_user')
              // document.cookie = 'username'+'='+username
              // document.cookie = 'password'+'='+password
            }

            dispatch('initialize')
            // store firebasetoken
            if(this.state.firebasetoken!=""){
              let data = {}
              data.user_id = response.data[0].id;
              data.token = this.state.firebasetoken
              // console.log(data)      
              await axios.put('/api/save_fb_token', data)//.then((response) => { console.log( response)} )              
            }
            if (response.data[0].role != "admin") {
              if(response.data[0].role =="user"){
                router.push({ path: '/tasks/1' });
              } else{
                router.push({ path: '/tasks/2' });
              }
            } else {
                router.push({ path: '/users' });
              }
          }
        })
        .catch(function (error) {
          console.log("dontknow",error)
          commit('loginfailed', true);

        })
    },
    logout({ commit }) {
      axios.post('/api/logout').then((response) => {
        if (response && response.data) {
          if (process.env.VUE_APP_BUILD_TARGET=="apprelease") {
             Preferences.set({
              key: 'username',
              value: JSON.stringify({
                name: ""
              })
            });
             Preferences.set({
              key: 'password',
              value: JSON.stringify({
                name: ""
              })
            });              
          }
          commit('current_user', null)
          router.push({ path: '/' });

        }
      })
    },
    //USERS DATA
    get_users({ state, commit}) {
      //load all users and commit
      axios.get("/api/users/all",{params:{weeks:state.weekshistory,alluser:state.usersettings.statusactiveusers}})
      // axios.get("/api/users/all")
        .then((response) => {
          commit('users', response.data)
        })
        .catch((e) => {
        console.log(">>>>",e)
        });
    },
    get_user({ state }, to) {
      //load all users and commit
      console.log("get user", to)
      let user = state.users.filter(u=>u.id==to.params.id)[0]
      // axios.get("/api/user/" + user.id, user).then((response) => {
        axios.get("/api/user/" + user.id, user).then((response) => {
          console.log("resp", response)
          for(var propt in response.data){
            console.log(propt + ': ' + response.data[propt]);
            Vue.set(user,propt,response.data[propt])

        }
          console.log(">USER>>>>>>>>>>", user)
        state.users.push(user)
      })
        .catch(() => {
        });
    },
    add_user({ state }, user) {
      axios.put("/api/user/" + user.id, user).then((response) => {
        if(response.data.error){
              vm.$modal.hide('popup_confirm')
              vm.$modal.show(popup_confirm, {
              message: response.data.errormessage.message,
              header: "Error adding user"
          }, {
              name: 'popup_confirm',
              draggable: false,
              height: 'auto',
              width: '90%'
          })
        } else {

          Vue.set(user, 'id', response.data.id)
          state.users.push(user)
          router.push({ path: '/user/' + response.data.id });
        }
      //dispatch('get_users'
        // Vue.set(state.users, response.data.id, response.data)
      })
    },
    add_contact({ state, dispatch }, user) {
      axios.put("/api/user/" + user.id, user).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding contact"
        }, {
            name: 'popup_confirm',
            draggable: false,
            height: 'auto',
            width: '90%'
        })
        } else {
          Vue.set(user, 'id', response.data.id)
          state.users.push(user)
          state.new_user_id = response.data.id
          // add new contact to current company
          axios.put("/api/companyrelations/" + state.current_company, { 'user_id': response.data.id }).then(() => {
            dispatch('get_companies')
          })
        }
      })
    
    },
    save_user({ getters }, user_id) {
      var user = getters.user_by_id(user_id)
      axios.put("/api/user/" + user_id, user).then(() => {

        // console.log("save user response ", response)
      })
    },
    delete_user(store, user_id) {
      axios.delete("/api/user/" + user_id)
    },
    save_user_workfield(store, { user_id, workfield_id }) {
      axios.put("/api/userworkfield/" + user_id, { 'workfield_id': workfield_id })
    },
    delete_user_workfield(store, { user_id, workfield_id }) {
      axios.delete("/api/userworkfield/" + user_id, { data: { 'workfield_id': workfield_id } })
    },
    save_avatar(store, { user_id, file }) {
      const formData = new FormData();
      formData.append('avatar', file);
      axios.post('/api/user/profileimage/' + user_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
      }).catch(() => {
      });
    },
    get_avatars({ commit }) {
      //load all users and commit
      axios.get("/api/usersavatares")
        .then((response) => {
          commit('avatars', response.data)
        })
        .catch(() => {
        });
    },
    delete_user_document(store, document_id) {
      axios.delete("/api/userdocument/" + document_id)
    },
    update_user_document(store, { document_id, name, expire }) {
      axios.put("/api/userdocument/" + document_id, { 'document_id': document_id, 'newexpires': expire, 'newname': name })

    },
    save_user_friend(store, { user_id, friend_id }) {
      axios.put("/api/userfriend/" + user_id, { 'friend_id': friend_id })
    },
    delete_user_friend(store, id) {
      axios.delete("/api/userfriend/" + id)
    },
    save_user_tag(store, { user_id, tag_id }) {
      axios.put("/api/usertag/" + user_id, { 'tag_id': tag_id })
    },
    delete_user_tag(store, id) {
      axios.delete("/api/usertag/" + id)
    },
    save_blocking_company(store, { user_id, company_id }) {
      axios.put("/api/usercompany/" + user_id, { company_id: company_id })
    },
    delete_blocking_company(store, company_id) {
      axios.delete("/api/usercompany/" + company_id)
    },
    //COMPANIES DATA
    get_companies({ commit }) {
      //load all companies and commit
      axios.get("/api/companies/all")
        .then((response) => {
          commit('companies', response.data)
        })
        .catch(() => {
        });
    },
    add_company({ state }, company) {
      axios.put("/api/company/" + company.id, company).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding company"
      }, {
          name: 'popup_confirm',
          draggable: false,
          height: 'auto',
          width: '90%'
      })
    } else {

        Vue.set(company, 'id', response.data.id)
        state.companies.push(company)
        router.push({ path: '/company/' + response.data.id })
    }
        //state.users.push(user)
        //        dispatch('get_companies')

        // Vue.set(state.users, response.data.id, response.data)
      })
    },
    save_company({ getters }, company_id) {
      var company = getters.company_by_id(company_id)
      axios.put("/api/company/" + company_id, company)
    },
    delete_company(store, company_id) {
      axios.delete("/api/company/" + company_id)
    },
    save_company_workfield(store, { company_id, workfield_id }) {
      axios.put("/api/companyworkfield/" + company_id, { 'workfield_id': workfield_id })
    },
    delete_company_workfield(store, { company_id, workfield_id }) {
      axios.delete("/api/companyworkfield/" + company_id, { data: { 'workfield_id': workfield_id } })
    },
    save_company_relations(store, { company_id, user_id }) {
      axios.put("/api/companyrelations/" + company_id, { 'user_id': user_id })
    },
    remove_company_relations(store, { company_id, user_id }) {console.log(">>>>>>>>",company_id, user_id)
      axios.delete("/api/companyrelations/" + company_id, { data: { 'user_id': user_id } })
    },
    save_company_tag(store, { company_id, tag_id }) {
      axios.put("/api/companytag/" + company_id, { 'tag_id': tag_id })
    },
    delete_company_tag(store, id) {
      axios.delete("/api/companytag/" + id)
    },
    get_company_avatars({ commit }) {
      axios.get("/api/companypics")
        .then((response) => {
          commit('companyavatars', response.data)
        })
        .catch(() => {
        });
    },
    delete_company_document(store, document_id) {
      axios.delete("/api/companydocument/" + document_id)
    },
    update_company_document(store, { document_id, name, expire , required}) {
      axios.put("/api/companydocument/" + document_id, { 'document_id': document_id, 'newexpires': expire, 'newname': name,  'required': parseInt(required) })
    },
    //PROJECTS
    get_projects({ commit }) {
      //load all users and commit
      axios.get("/api/projects/all")
        .then((response) => {
          commit('projects', response.data)
        })
        .catch(() => {
        });
    },
    add_project({ state }, project) {
      axios.put("/api/project/" + project.id, project).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding project"
          }, {
              name: 'popup_confirm',
              draggable: false,
              height: 'auto',
              width: '90%'
          })
        } else {

        Vue.set(project, 'id', response.data.id)
        state.projects.push(project)

        router.push({ path: '/project/' + response.data.id });
        }

        //  dispatch('get_projects')

        // Vue.set(state.users, response.data.id, response.data)
      })
    },
    save_project({ getters }, project_id) {
      var project = getters.project_by_id(project_id)
      axios.put("/api/project/" + project_id, project)
    },
    delete_project(store, project_id) {
      axios.delete("/api/project/" + project_id)
    },
    save_project_relations(state, { project_id, user_id }) {
      axios.put("/api/projectrelations/" + project_id, { 'user_id': user_id })
    },
    remove_project_relations(store, { project_id, user_id }) {
      axios.delete("/api/projectrelations/" + project_id, { data: { 'user_id': user_id } })
    },
    save_project_workfield(store, { project_id, workfield_id }) {
      axios.put("/api/projectworkfield/" + project_id, { 'workfield_id': workfield_id })
    },
    delete_project_workfield(store, { project_id, workfield_id }) {
      axios.delete("/api/projectworkfield/" + project_id, { data: { 'workfield_id': workfield_id } })
    },
    //CONTRACTS
    get_contracts({ state, commit }) {
      //load all users and commit
      axios.get("/api/contracts/all",{params:{weeks:state.weekshistory}})
        .then((response) => {
          commit('contracts', response.data)
        })
        .catch(() => {
        });
    },
    add_contract({ dispatch }, contract) {
      axios.put("/api/contracts/" + contract.id, contract).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding contract"
        }, {
            name: 'popup_confirm',
            draggable: false,
            height: 'auto',
            width: '90%'
        })
        } else {
          Vue.set(contract, 'id', response.data.id)
          dispatch('get_contracts')
        }

        // Vue.set(state.users, response.data.id, response.data)
      })
    },
    save_contract({ getters }, contract_id) {
      var contract = getters.contract_by_id(contract_id)
      axios.put("/api/contracts/" + contract_id, contract)
      Vue.set(contract)

    },
    async generate_contract({ getters }, contract_id) {
      var contract = getters.contract_by_id(contract_id)
      await axios.put("/api/generate_contract/" + contract.id, contract).then((response) => {
        Vue.set(contract, 'id', response.data.id)
      })
    },
    async generate_urenbon({ getters }, contract_id) {
      var contract = getters.contract_by_id(contract_id)
      await axios.put("/api/generate_urenbon/" + contract.id, contract).then((response) => {
        Vue.set(contract, 'id', response.data.id)
      })
    },
    async generate_contract_company({ getters }, contract_id) {
      var contract = getters.contract_by_id(contract_id)
      await  axios.put("/api/generate_company_contract/" + contract.id, contract).then((response) => {
        Vue.set(contract, 'id', response.data.id)
      })
    },
    //BRANCHES
    get_branches({ commit }) {
      //load all branches and commit
      axios.get("/api/branches/all")
        .then((response) => {
          commit('branches', response.data)
        })
        .catch(() => {
        });
    },
    add_branche({ state }, branche) {
      axios.put("/api/branche/" + branche.id, branche).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding branche"
      }, {
          name: 'popup_confirm',
          draggable: false,
          height: 'auto',
          width: '90%'
      })
    } else {

        Vue.set(branche, 'id', response.data.id)
        state.branches.push(branche)
        router.push({ path: '/branche/' + response.data.id })
        //dispatch('get_branches')
    }
      })
    },
    save_branche({ getters }, branche_id) {
      var branche = getters.branche_by_id(branche_id)
      axios.put("/api/branche/" + branche_id, branche)
    },
    delete_branche(store, branche_id) {
      axios.delete("/api/branche/" + branche_id)
    },
    //WORKFIELDS
    get_workfields({ commit }) {
      axios.get("/api/workfields/all")
        .then((response) => {
          commit('workfields', response.data)
        })
        .catch(() => {
        });
    },
    add_workfield({ dispatch }, workfield) {
      axios.put("/api/workfield/" + workfield.id, workfield).then((response) => {
        if(response.data.error){
          vm.$modal.hide('popup_confirm')
          vm.$modal.show(popup_confirm, {
          message: response.data.errormessage.message,
          header: "Error adding workfield"
      }, {
          name: 'popup_confirm',
          draggable: false,
          height: 'auto',
          width: '90%'
      })
    } else {

        Vue.set(workfield, 'id', response.data.id)
        dispatch('get_workfields')
    }
        // Vue.set(state.users, response.data.id, response.data)
      })
    },
    save_workfield({ getters }, workfield_id) {
      var workfield = getters.workfield_by_id(workfield_id)
      axios.put("/api/workfield/" + workfield_id, workfield)
    },
    delete_workfield(store, workfield_id) {
      axios.delete("/api/workfield/" + workfield_id)
    },
    //HOURCATEGORIES
    get_hourcategories({ commit }) {
      //load all branches and commit
      axios.get("/api/hourcategories/all")
        .then((response) => {
          commit('hourcategories', response.data)
        })
        .catch(() => {
        });
    },
    add_hourcategory({ state }, hourcategory) {
      axios.put("/api/hourcategory/" + hourcategory.id, hourcategory).then((response) => {
        Vue.set(hourcategory, 'id', response.data.id)
        state.hourcategories.push(hourcategory)
        router.push({ path: '/hours/' + response.data.id })
        //        dispatch('get_hourcategories')

      })
    },
    save_hourcategory({ getters }, hourcategory_id) {
      var hourcategory = getters.hourcategory_by_id(hourcategory_id)
      axios.put("/api/hourcategory/" + hourcategory_id, hourcategory)
    },
    delete_hourcategory(store, hourcategory_id) {
      axios.delete("/api/hourcategory/" + hourcategory_id)
    },
    //HOURCODES
    get_hourcodes({ commit }) {
      axios.get("/api/hourcodes/all")
        .then((response) => {
          commit('hourcodes', response.data)
        })
        .catch(() => {
        });
    },
    add_hourcode({ dispatch }, hourcode) {
      axios.put("/api/hourcode/" + hourcode.id, hourcode).then((response) => {
        Vue.set(hourcode, 'id', response.data.id)
        dispatch('get_hourcodes')
      })
    },
    save_hourcode({ getters }, hourcode_id) {
      var hourcode = getters.hourcode_by_id(hourcode_id)
      axios.put("/api/hourcode/" + hourcode_id, hourcode)
    },
    delete_hourcode(store, hourcode_id) {
      axios.delete("/api/hourcode/" + hourcode_id)
    },
    //PLANNING
    get_planning({ state, commit }) {
      // if(this.state.weekshistory){
      //   let m = new Date()
      //   var day = m.getDay(),
      //   diff = m.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      //   m.setDate(diff);        
      //   m.setDate(m.getDate() - (7*this.state.weekshistory));
      //   // console.log(m, this.state.weekshistory)
      //   // var dd = String(m.getDate()).padStart(2, '0');
      //   // var mm = String(m.getMonth() + 1).padStart(2, '0'); //January is 0!
      //   var yyyy = m.getFullYear();
      //   let ddate= yyyy + "-01-01" //+ mm + "-" + dd  
      //   axios.get("/api/planning/all",
      //   {
      //   params: {
      //     date: ddate
      //   }})
      //   .then((rrr) => {
      //     commit('planning', rrr.data)
      //   })
      //   .catch(() => {
      //   });        
      // } else {
        // axios.get("/api/planning/all")
        axios.get("/api/planning/all",{params:{weeks:state.weekshistory}})

          .then((response) => {
            commit('planning', response.data)
          })
          .catch(() => {
          });
        // }
    },
    add_planning({ state, dispatch }, planning) {
      axios.put("/api/planning/" + planning.id, planning).then((response) => {
        Vue.set(planning, 'id', response.data.id)
        state.last_contract_id = response.data.contract_id
        dispatch('get_planning')
      })
    },
    save_planning({ getters }, planning_id) {
      var planning = getters.planning_by_id(planning_id)
      axios.put("/api/planning/" + planning_id, planning)
    },
    delete_planning(store, planning_id) {
      axios.delete("/api/planning/" + planning_id)
    },
    //TAGS
    get_tags({ commit }) {
      //load all tags and commit
      axios.get("/api/tags/all")
        .then((response) => {
          commit('tags', response.data)
        })
        .catch(() => {
        });
    },
    add_tag({ dispatch }, tag) {
      axios.put("/api/tag/" + tag.id, tag).then((response) => {
        Vue.set(tag, 'id', response.data.id)
        dispatch('get_tags')
      })
    },
    save_tag({ getters }, tag_id) {
      var tag = getters.tag_by_id(tag_id)
      axios.put("/api/tag/" + tag_id, tag)
    },
    delete_tag(store, tag_id) {
      axios.delete("/api/tag/" + tag_id)
    },
    //HOURS
    get_hours({ commit }) {
      //load all tags and commit
      if(this.state.weekshistory){
        let m = new Date()
        var day = m.getDay(),
        diff = m.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        m.setDate(diff);        
        m.setDate(m.getDate() - (7*this.state.weekshistory));
        var dd = String(m.getDate()).padStart(2, '0');
        var mm = String(m.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = m.getFullYear();
        let ddate= yyyy + "-" + mm + "-" + dd  
        axios.get("/api/hours/all",
        {
        params: {
          date: ddate
        }})
        .then((rrr) => {
          commit('hours', rrr.data)
        })
        .catch(() => {
        });        
      } else {
        axios.get("/api/hours/all")
        .then((rrr) => {
          commit('hours', rrr.data)
        })
        .catch(() => {
        });        
      }

    },
    get_user_hours({ commit }, params) {
      // console.log( " get hours for ", params.params.id)
      axios.get("/api/hours/get_user_hours/"+params.params.id)
      .then((rrr) => {
        commit('hours', rrr.data)
      })
      .catch(() => {
      });       
    },
    add_hours({ state }, hours) {
      // console.log("ADD HOURS ", JSON.stringify(hours))
      axios.put("/api/hours/" + hours.id, hours).then((response) => {
        Vue.set(hours, 'id', response.data.id)
        // console.log("GETTING NEW HOURS!!!!" ,JSON.stringify(hours))
        state.hours.push(hours)
        // dispatch('hello')
      })
    },
    save_hours({ getters }, hours_id) {
      var hours = getters.hours_by_id(hours_id)
      axios.put("/api/hours/" + hours_id, hours)
    },
    delete_hours(store, hours_id) {
      axios.delete("/api/hours/" + hours_id)
    },
    async agree_hours({ getters }, hours_id) {
      var hours = getters.hours_by_id(hours_id)
      if (hours.agree_company != 1) {
        hours.agree_date = new Date().toUTCString()
      }
      hours.agree_company = 1;
      await axios.put("/api/agreehours/" + hours_id, hours)
    },
    close_hours({ getters }, hours_id) {
      var hours = getters.hours_by_id(hours_id)
      hours.close_hours = 1;
      axios.put("/api/closehours/" + hours_id, hours)
    },
    //SETTINGS
    get_settings({ commit }) {
      // console.log(">>>>get_settings")
      axios.get("/api/settings/")
        .then((response) => {
          commit('settings', response.data)
        })
        .catch(() => {
        })

      axios.get("/api/roles/")
        .then((response) => {
          commit('roles', response.data)
        })
        .catch(() => {
        })
    },
    save_settings({ state, commit }) {
      axios.patch("/api/settings/", state.settings)
        .then((response) => {
          commit('settings', response.data)
        })
        .catch(() => {
        })
    },
    //DECLARATIES
    get_declaraties({ commit }) {
      axios.get("/api/declaraties/all")
        .then((response) => {
          commit('declaraties', response.data)
        })
        .catch(() => {
        });
    },
    add_declaratie({ dispatch }, declaratie) {
      axios.put("/api/declaratie/" + declaratie.id, declaratie).then((response) => {
        Vue.set(declaratie, 'id', response.data.id)
        dispatch('get_declaraties')
      })
    },
    save_declaratie({ getters }, declaratie_id) {
      var declaratie = getters.declaratie_by_id(declaratie_id)
      axios.put("/api/declaratie/" + declaratie_id, declaratie)
    },
    delete_declaratie(store, declaratie_id) {
      axios.delete("/api/declaratie/" + declaratie_id)
    },
    //DOCUMENTS
    get_documents({ commit }) {
      axios.get("/api/maindocument/all")
        .then((response) => {
          commit('documents', response.data)
        })
        .catch(() => {
        });
    },
    add_document({ dispatch }, documents) {
      axios.put("/api/maindocument/" + documents.id, documents).then((response) => {
        Vue.set(documents, 'id', response.data.id)
        dispatch('get_declaraties')
      })
    },
    save_document({ getters }, document_id) {
      var document = getters.document_by_id(document_id)
      axios.put("/api/maindocument/" + document_id, document)
    },
    delete_document(store, document_id) {
      axios.delete("/api/maindocument/" + document_id)
    },
    //URENBONNEN
    get_urenbonnen({ commit }) {
      if(this.state.weekshistory){
        let m = new Date()
        var day = m.getDay(),
        diff = m.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        m.setDate(diff);        
        m.setDate(m.getDate() - (7*this.state.weekshistory));
        var dd = String(m.getDate()).padStart(2, '0');
        var mm = String(m.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = m.getFullYear();
        let ddate= yyyy + "-" + mm + "-" + dd  
        axios.get("/api/urenbon/all",
        {
        params: {
          date: ddate
        }})
        .then((rrr) => {
          commit('urenbonnen', rrr.data)
        })
        .catch(() => {
        });        
      } else {

        axios.get("/api/urenbon/all")
          .then((response) => {
            commit('urenbonnen', response.data)
          })
          .catch(() => {
          });
        }
    },
    add_urenbon({ dispatch }, urenbon) {
      axios.put("/api/urenbon/" + urenbon.id, urenbon).then((response) => {
        Vue.set(urenbon, 'id', response.data.id)
        dispatch('get_urenbonnen')
      })
    },
    save_urenbon({ getters }, document_id) {
      var urenbon = getters.urenbon_by_id(document_id)
      axios.put("/api/urenbon/" + document_id, urenbon)
    },
    delete_urenbon(store, document_id) {
      axios.delete("/api/urenbon/" + document_id)
    },
    //FACTUREN
    async get_facturen({ commit ,state}) {
      await axios.get("/api/facturen/all",{params:{weeks:state.weekshistory}})
        .then((response) => {
          commit('facturen', response.data)
        })
        .catch(() => {
        });
    },
     async add_factuur({ state }, factuur) {
      await axios.put("/api/factuur/", factuur).then((response) => {
        Vue.set(factuur, 'id', response.data.id)
        state.facturen.push(factuur)
      })
    },
    save_factuur({ getters }, factuur_id) {
      var factuur = getters.factuur_by_id(factuur_id)
      axios.put("/api/factuur/" + factuur_id, factuur)
    },
    delete_factuur(store, factuur_id) {
      axios.delete("/api/remove_factuur/" + factuur_id)
    },
    async get_combinedfacturen({ commit ,state}) {
      await axios.get("/api/combinedfacturen/all",{params:{weeks:state.weekshistory}})
        .then((response) => {
          commit('combinedfacturen', response.data)
        })
        .catch(() => {
        });
      },
     async add_combinedfactuur({ state }, factuur) {
      await axios.put("/api/combinedfactuur/", factuur).then((response) => {
        Vue.set(factuur, 'id', response.data.id)
        state.combinedfacturen.push(factuur)
      })
    },
    save_combinedfactuur({ getters }, factuur_id) {
      var factuur = getters.combinedfactuur_by_id(factuur_id)
      axios.put("/api/combinedfactuur/" + factuur_id, factuur)
    },
    delete_combinedfactuur(store, factuur_id) {
      axios.delete("/api/remove_combinedfactuur/" + factuur_id)
    },
    get_invoiceextra({ commit }) {
      axios.get("/api/invoiceextra")
        .then((response) => {
          commit('invoiceextra', response.data)
        })
        .catch(() => {
        });
    },
    //EMAILSENDERS
    get_emailsenders({ commit }) {
      axios.get("/api/emailsenders/all")
        .then((response) => {
          commit('emailsenders', response.data)
        })
        .catch(() => {
        })
    },
    //authemailsenders
    get_authemailsenders({commit}) {
      axios.get("/api/msal/getusers")
      .then((response) =>{
        commit('authemailsenders', response.data)
      })
      .catch(() => {
      })
    },
    add_emailsender({ state }, emailsender) {
      axios.put("/api/emailsender/", emailsender).then((response) => {
        Vue.set(emailsender, 'id', response.data.id)
        state.emailsenders.push(emailsender)
      })
    },
    save_emailsender({ getters }, emailsender_id) {
      var emailsender = getters.emailsender_by_id(emailsender_id)
      axios.put("/api/emailsender/" + emailsender_id, emailsender)
    },
    delete_emailsender(store, emailsender_id) {
      axios.delete("/api/emailsender/" + emailsender_id)
    },
    //PUBLIC
    get_public_projects({ commit }) {
      //load all users and commit
      axios.get("/api/public_projects")
        .then((response) => {
          commit('projects', response.data)
        })
        .catch(() => {
        });
    }, 
    public_settings({ commit }) {
      //load all users and commit
      axios.get("/api/public_settings")
        .then((response) => {
          commit('settings', response.data)
        })
        .catch(() => {
        });
    }, 
    //BICCODES
    get_biccodes({ commit }) {
      //load all tags and commit
      axios.get("/api/biccodes/all")
        .then((response) => {
          commit('biccodes', response.data)
        })
        .catch(() => {
        });
    },
    add_biccode({ dispatch }, biccode) {
      axios.put("/api/biccode/" + biccode.id, biccode).then((response) => {
        Vue.set(biccode, 'id', response.data.id)
        dispatch('get_biccodes')
      })
    },
    save_biccode({ getters }, biccode_id) {
      var biccode = getters.biccode_by_id(biccode_id)
      axios.put("/api/biccode/" + biccode_id, biccode)
    },
    delete_biccode(store, biccode_id) {
      axios.delete("/api/biccode/" + biccode_id)
    },    
    //NATIONALITIES
    get_nationalities ({ commit }) {
      //load all tags and commit
      axios.get("/api/nationalities/all")
        .then((response) => {
          commit('nationalities', response.data)
        })
        .catch(() => {
        });
    },
    add_nationality({ dispatch }, nationality) {
      axios.put("/api/nationality/" + nationality.id, nationality).then((response) => {
        Vue.set(nationality, 'id', response.data.id)
        dispatch('get_nationalities')
      })
    },
    save_nationality({ getters }, nationality_id) {
      var nationality = getters.nationality_by_id(nationality_id)
      axios.put("/api/nationality/" + nationality_id, nationality)
    },
    delete_nationality(store, nationality_id) {
      axios.delete("/api/nationality/" + nationality_id)
    },  
    
    //planningrules
    get_planningrules ({ commit }) {
      //load all tags and commit
      axios.get("/api/planningrules/all")
        .then((response) => {
          commit('planningrules', response.data)
        })
        .catch(() => {
        });
    },
    add_planningrule({ dispatch }, planningrule) {
      axios.put("/api/planningrule/" + planningrule.id, planningrule).then((response) => {
        Vue.set(planningrule, 'id', response.data.id)
        dispatch('get_planningrules')
      })
    },
    save_planningrule({ getters }, planningrule_id) {
      var planningrule = getters.planningrule_by_id(planningrule_id)
      axios.put("/api/planningrule/" + planningrule_id, planningrule)
    },
    delete_planningrule(store, planningrule_id) {
      axios.delete("/api/planningrule/" + planningrule_id)
    },  

    //planningrule_types
    get_planningruletypes ({ commit }) {
      //load all tags and commit
      axios.get("/api/planningrules_types/all")
        .then((response) => {
          commit('planningruletypes', response.data)
        })
        .catch(() => {
        });
    },
    add_planningruletypes({ dispatch }, planningrules_type) {
      axios.put("/api/planningrules_type/" + planningrules_type.id, planningrules_type).then((response) => {
        Vue.set(planningrules_type, 'id', response.data.id)
        dispatch('get_planningrules')
      })
    },
    save_planningruletype({ getters }, planningruletype_id) {
      var planningruletype = getters.planningruletype_by_id(planningruletype_id)
      axios.put("/api/planningrules_type/" + planningruletype_id, planningruletype)
    },
    delete_planningruletype(store, planningruletype_id) {
      axios.delete("/api/planningrules_type/" + planningruletype_id)
    },      

    add_notification({ state }, notification){
      if(state.notifications.filter(n => n.id==notification.id).length==0) {
        notification.seen = false
        state.notifications.push(notification)
      }
    },
    get_todo({ commit }) {
      axios.get("/api/todo/all")
        .then((response) => {
          commit('todo', response.data)
        })
        .catch(() => {
        })
    },    
    add_todo({ state }, todo) {
      axios.put("/api/todo/" + todo.id, todo).then((response) => {
        Vue.set(todo, 'id', response.data.id)
        state.todo.push(todo)
      })
    },
    add_tostate_todo({ state }, todo) {
        state.todo.push(todo)
    },
    save_todo({ getters }, todo_id) {
      var todo = getters.todo_by_id(todo_id)
      axios.put("/api/todo/" + todo_id, todo).then(() => {

        // console.log("save user response ", response)
      })
    },  
    delete_todo(store, todo_id) {
      axios.delete("/api/todo/" + todo_id)
    }, 
    get_pms({ commit }) {
      axios.get("/api/pms/all")
        .then((response) => {
          commit('pms', response.data)
        })
        .catch(() => {
        })
    },    
    add_pm({ dispatch }, pm) {
      console.log("addpm", pm)
      axios.put("/api/pms/" + pm.id, pm).then((response) => {
        Vue.set(pm, 'id', response.data.id)
        dispatch('get_pms')
      })
    },
    save_pm({ getters }, pm_id) {
      var pm = getters.pm_by_id(pm_id)
      axios.put("/api/pms/" + pm_id, pm).then(() => {

        // console.log("save user response ", response)
      })
    },  
    delete_pm(store, pm_id) {
      axios.delete("/api/pms/" + pm_id)
    },
    //newsletters
    get_newsletters({ commit }) {
      //load all tags and commit
      axios.get("/api/newsletters/all")
        .then((response) => {
          commit('newsletters', response.data)
        })
        .catch(() => {
        });
    },
    add_newsletter({ dispatch }, newsletter) {
      axios.put("/api/newsletters/" + newsletter.id, newsletter).then((response) => {
        Vue.set(newsletter, 'id', response.data.id)
        dispatch('get_newsletters')
      })
    },
    save_newsletter({ getters }, newsletter_id) {
      var newsletter = getters.newsletter_by_id(newsletter_id)
      axios.put("/api/newsletter/" + newsletter_id, newsletter)
    },
    delete_newsletter(store, newsletter_id) {
      axios.delete("/api/newsletter/" + newsletter_id)
    },
    //signature
    get_signatures({ commit }) {
      //load all tags and commit
      axios.get("/api/workhourscheck/all")
        .then((response) => {
          commit('signatures', response.data)
        })
        .catch(() => {
        });
    },
    add_signature({ dispatch }, signature) {
      axios.put("/api/workhourscheck/" + signature.id, signature).then((response) => {
        Vue.set(signature, 'id', response.data.id)
        dispatch('get_signatures')
      })
    },
    save_signature({ getters }, signature_id) {
      var signature = getters.signature_by_id(signature_id)
      axios.put("/api/workhourscheck/" + signature_id, signature)
    },
    delete_signature(store, signature_id) {
      axios.delete("/api/workhourscheck/" + signature_id)
    },
    //RESOURCES
    get_resources({ commit}) {
      //load all resources and commit
      axios.get("/api/resources/all")
        .then((response) => {
          commit('resources', response.data)
        })
        .catch(() => {
        });
    },
    add_resource({ dispatch }, resource) {
      axios.put("/api/resource/" + resource.id, resource).then((response) => {
        Vue.set(resource, 'id', response.data.id)
        dispatch('get_resources')
      })
    },
    save_resource({ getters }, resource_id) {
      var resource = getters.resource_by_id(resource_id)
      axios.put("/api/resource/" + resource_id, resource)
    },
    delete_resource(store, resource_id) {
      axios.delete("/api/resource/" + resource_id)
    },        
    //RESOURCES
    get_ffwax({ commit }) {
      //load all ffwaxs and commit
      axios.get("/api/ffwax/all")
        .then((response) => {
          commit('ffwax', response.data)
        })
        .catch(() => {
        });
    },
    add_ffwax({ dispatch }, ffwax) {
      axios.put("/api/ffwax/" + ffwax.id, ffwax).then((response) => {
        Vue.set(ffwax, 'id', response.data.id)
        dispatch('get_ffwax')
      })
    },
    save_ffwax({ getters }, ffwax_id) {
      console.log("saveffwax ",ffwax_id)
      var ffwax = getters.ffwax_by_id(ffwax_id)
      axios.put("/api/ffwax/" + ffwax_id, ffwax)
    },
    delete_ffwax(store, ffwax_id) {
      axios.delete("/api/ffwax/" + ffwax_id).then(()=>{
        this.dispatch('get_ffwax')
      })
    },    
    //RESOURCES
    get_projectresources({ commit }) {
      //load all projectresources and commit
      axios.get("/api/projectresources/all")
        .then((response) => {
          commit('projectresources', response.data)
        })
        .catch(() => {
        });
    },
    add_projectresource({ dispatch }, projectresource) {
      axios.put("/api/projectresource/" + projectresource.id, projectresource).then((response) => {
        Vue.set(projectresource, 'id', response.data.id)
        dispatch('get_projectresources')
      })
    },
    save_projectresource({ getters }, projectresource_id) {
      var projectresource = getters.projectresource_by_id(projectresource_id)
      axios.put("/api/projectresource/" + projectresource_id, projectresource)
    },
    delete_projectresource(store, projectresource_id) {
      axios.delete("/api/projectresource/" + projectresource_id)
    },    
    //carousel
    async get_carousel_people({ commit,state }) {
      if(state.settings.useCarousel){
        if(state.carouselToken==null){
          var token=null;
          var id = null;
          await axios.post(state.carouselURL+"api/login",{username:state.settings.carouselusername, password:state.settings.carouselpassword})
          .then(function (response) {
            token =  response.data[1]
            id = response.data[0].id
          })
          .catch(function (error) {
            console.log(error);
          });
          commit('carouselID',id)
          commit('carouselToken',token)
          // console.log("<TOKENstore",token)
          // console.log("<this.TOKENstore ",state.carouselToken)
        }
        // await this.getCarouselToken()

        await axios.get(state.carouselURL+'api/people/all',  {
                headers: { Authorization: `Bearer ${state.carouselToken}` }
              }
        )
        .then((response) => {
          // console.log(">>>>get_carousel_people>>",response.data)
          commit('carouselPeople', response.data)
        })
      } 
      },  
    async get_carousel_professions({ commit,state }) {
      if(state.settings.useCarousel){
        if(state.carouselToken==null){
          var token=null;
          var id = null;
          await axios.post(state.carouselURL+"api/login",{username:state.settings.carouselusername, password:state.settings.carouselpassword})
          .then(function (response) {
            token =  response.data[1]
            id = response.data[0].id
          })
          .catch(function (error) {
            console.log(error);
          });
          commit('carouselID',id)
          commit('carouselToken',token)
          console.log("<TOKENstore",token)
          console.log("<this.TOKENstore ",state.carouselToken)
        }

        await axios.get(state.carouselURL+'api/get_professions',  {
                headers: { Authorization: `Bearer ${state.carouselToken}` }
              }
        )
        .then((response) => {
          console.log(">>>>carouselProfessions>>",response.data)
          commit('carouselProfessions', response.data)
        })
      } 
      },  
       
  },
  modules: {
  },

})

export default store
store.dispatch('get_settings')
